import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { IngredientSlide } from '../IngredientSlide';
import { IngredientRow } from '../IngredientRow';
import { Spinner } from '../Spinner';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { extractHostname } from '../_helpers';
import Modal from 'react-modal';

import { userActions, cocktailActions, alertActions } from '../_actions';
import { RecipeCategory } from '../RecipeCategory';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    fontSize              : '150%',
    padding: 0
  },
  overlay: {zIndex: 1000}
};

class PartyTime extends React.Component {
  constructor(props) {
    super(props);

    // begin modal
    this.state = {
      modalIsOpen: false,
      selected_name: ''
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    // end modal

    const {user} = this.props;

    this.state = {
      userModified: {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        cabinet: user.cabinet,
        favorites: user.favorites ? user.favorites : [],
        keyIngredients: user.keyIngredients ? user.keyIngredients : [],
        access_level: user.access_level,
        _id: user._id
      },
      //selectedItem: '',
      submitted: false,
      storeShelves: [],
      keyIngredients: []
    };

    this.onItemClick = this.onItemClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ingredients.items) {
      const toDelete = new Set(nextProps.user.cabinet);
      const storeShelves = nextProps.ingredients.items.filter(ingredientItem => !toDelete.has(ingredientItem.machine_name));

      var img_urls = [];
      var len = storeShelves.length;
      for (var i = 0; i < len; i++) {
        img_urls.push(storeShelves[i].img_url);
      }

      this.setState({
        storeShelves,
        img_urls
      })
    }
    if (nextProps.user) {
      this.setState({
        userModified: {
          first_name: nextProps.user.first_name,
          last_name: nextProps.user.last_name,
          email: nextProps.user.email,
          cabinet: nextProps.user.cabinet,
          favorites: nextProps.user.favorites ? nextProps.user.favorites : [],
          keyIngredients: nextProps.user.keyIngredients ? nextProps.user.keyIngredients : [],
          access_level: nextProps.user.access_level,
          _id: nextProps.user._id
        }
      });
      //this.props.dispatch(cocktailActions.getMyRecipes(nextProps.user.cabinet, nextProps.user.keyIngredients));

    }
  }

  componentDidMount() {
    this.props.dispatch(cocktailActions.getAllIngredients());
    this.props.dispatch(cocktailActions.getMyRecipes(this.state.userModified.cabinet, []));
  }

  onItemClick(machine_name) {

    const {userModified} = this.state;
    const {loggedIn} = this.props;

    let joined = userModified.cabinet.concat(machine_name);

    let userModifiedNew = {
      ...userModified,
      ['cabinet']: joined
    };
    this.setState({
      //selectedItem: machine_name,
      userModified: userModifiedNew,
      submitted: true
    });

    const {dispatch} = this.props;
    dispatch(userActions.update(userModifiedNew, false, `${machine_name.replace(/_/g, ' ').capitalize()} added to your bar!`));
    dispatch(cocktailActions.getMyRecipes(userModifiedNew.cabinet, userModifiedNew.keyIngredients));
  }

  // begin modal
  openModal(recipe, img_url) {
    if (recipe.name) {
      this.setState({
        modalIsOpen: true,
        selected_machine_name: recipe.machine_name,
        selected_name: recipe.name,
        selected_url: recipe.recipe_url,
        selected_domain: extractHostname(recipe.recipe_url),
        selected_img_url: img_url,
        selected_ingredients: recipe.ingredients,
        selected_measurements: recipe.measurements
      });
    }
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = 'red'; // '#f00';
    this.subtitle.style.paddingTop = '1.5rem';
    this.subtitle.style.fontSize = '150%';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  addToFavorites(recipe_machine_name) {
    const { userModified } = this.state;

    if (userModified.favorites.includes(recipe_machine_name)) {
      const index = userModified.favorites.indexOf(recipe_machine_name);
      userModified.favorites.splice(index, 1);

      // remove from favorites collection:
      this.props.dispatch(cocktailActions.addRemoveFavoritesCollection(userModified.email, recipe_machine_name, false));

    } else {
      userModified.favorites = userModified.favorites.concat(recipe_machine_name);

      // add from favorites collection:
      this.props.dispatch(cocktailActions.addRemoveFavoritesCollection(userModified.email, recipe_machine_name, true));
    }

    let userModifiedNew = {
      ...userModified,
      ['favorites']: userModified.favorites
    };

    this.setState({
      selectedRecipeItem: recipe_machine_name,
      userModified: userModifiedNew,
      submitted: true
    });

    const { dispatch } = this.props;
    dispatch(userActions.update(userModifiedNew, false));

    this.setState({modalIsOpen: false});
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
   // end modal

  clearFeaturedIngredients(userModified) {
    //const {  } = this.state;

    let user = {
      ...userModified,
      ['keyIngredients']: []
    };

    const {dispatch} = this.props;
    dispatch(userActions.update(user, false));
    dispatch(cocktailActions.getMyRecipes(user.cabinet, user.keyIngredients));
  }

  render() {
    const { user, ingredients, my_recipes, alert, dispatch } = this.props;
    const { userModified, storeShelves } = this.state;

    let sweetCocktails = new Array();
    let bitterCocktails = new Array();
    let strongCocktails = new Array();
    let creamyCocktails = new Array();
    let frozenCocktails = new Array();
    let otherCocktails = new Array();
    let countCategories = 5;

    if (my_recipes.items) {

      let SweetAdd = 0, StrongAdd = 0, CreamyAdd = 0, BitterAdd = 0, FrozenAdd = 0;
      for (let i = 0; i < my_recipes.items.length; i++) {

        if (my_recipes.items[i].missing.length > 0) {
          continue;
        }

        if (userModified.favorites && userModified.favorites.includes(my_recipes.items[i].machine_name)) {
          my_recipes.items[i].favorite = true;
        } else {
          my_recipes.items[i].favorite = false;
        }
        switch (my_recipes.items[i].category) {
          case 'Sweet':
            sweetCocktails.push(my_recipes.items[i]);
            SweetAdd = 1;
            break;
          case 'Strong':
            strongCocktails.push(my_recipes.items[i]);
            StrongAdd = 1;
            break;
          case 'Creamy':
            creamyCocktails.push(my_recipes.items[i]);
            CreamyAdd = 1;
            break;
          case 'Bitter':
            bitterCocktails.push(my_recipes.items[i]);
            BitterAdd = 1;
            break;
          case 'Frozen':
            frozenCocktails.push(my_recipes.items[i]);
            FrozenAdd = 1;
            break;
          case 'Other':
            otherCocktails.push(my_recipes.items[i]);
            break;
        }
      }
      countCategories = SweetAdd + StrongAdd + CreamyAdd + BitterAdd + FrozenAdd;
    }

    let liquorStore = new Array();
    let groceryStore = new Array();
    if (storeShelves) {
      for (let i = 0; i < storeShelves.length; i++) {
        switch (storeShelves[i].category) {
          case 'Liquor':
          case 'Liqueur':
          case 'Wine':
            liquorStore.push(storeShelves[i]);
            break;
          default:
            groceryStore.push(storeShelves[i]);
        }
      }
    }

    String.prototype.capitalize = function() {
      return this.charAt(0).toUpperCase() + this.slice(1);
    }

    const parent  = { width: `${(this.state.selected_ingredients * 55) - 1}px`, height: '20rem', whiteSpace: 'nowrap' }
    let tabCt = 0;

    if (alert.addToBarMessage) {
      setTimeout(function(){
        dispatch(alertActions.addToBarClear());
      }, 5000)
    }

        // prepare modal ingredient graphic
        let measurement_reversed = [];
        let ingredients_reverse = [];
        let fullAmount = 0;
        let runningTotal = 0;
        let randomColor = '';
    if (this.state.selected_measurements) {
      measurement_reversed = this.state.selected_measurements.slice().reverse();
      ingredients_reverse = this.state.selected_ingredients.slice().reverse();
    
      function getSum(total, num) {
        return total + num;
      }
    
      fullAmount = measurement_reversed.reduce(getSum);
    }
    // end prepare modal ingredient graphic

    return (
      <div>

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
        <section style={{ height: '100%', boxSizing: 'border-box', margin: '0 auto', background: 'white', position: 'relative'}}>
          {ingredients_reverse.map((this_recipe_ingredient, ingred_index) =>
              <div key={ingred_index} class="full-width-borders" style={{backgroundColor: randomColor = this.getRandomColor(), borderLeft: '600rem solid ' + randomColor, borderRight: '600rem solid ' + randomColor, top: ((((runningTotal += measurement_reversed[ingred_index]) - measurement_reversed[ingred_index]) / fullAmount) * 100) + "%", height: (measurement_reversed[ingred_index] / fullAmount * 100) + "%" }}><div style={{marginLeft: '1rem'}}>{this_recipe_ingredient.replace(/_/g, ' ')}</div></div>
          )}
        
        <section style={{ height: '100%', boxSizing: 'border-box', margin: '0 auto', width: '50rem', background: 'white', position: 'relative'}}>
          <div className="text-center current-cocktail" style={{margin: '0 auto'}}>


            <h2 style={{color: 'rgb(255, 0, 0)'}} ref={subtitle => this.subtitle = subtitle}>{this.state.selected_name}</h2>

            <div style={{display: 'flex', justifyContent: 'space-around' }}>
              <div style={{width: '190px', height: '100%', padding: '20px'}}>

{/*<strong>{JSON.stringify(this.state.selected_ingredients)}</strong>*/}
Recipe:
                <table className="ingredient-table">
                  <tr><th>US</th><th>Metric</th><th>Ingredient</th></tr>
                {this.state.selected_ingredients && this.state.selected_ingredients.map((this_recipe_measurement, meas_index) =>
                <IngredientRow meas_index={meas_index} machine_name={this_recipe_measurement} selected_measurements={this.state.selected_measurements} ingredients={ingredients}/>
                )}
                </table>
                {this.state.userModified.favorites && !this.state.userModified.favorites.includes(this.state.selected_machine_name) &&
                <button style={{width: '100%', color: '#39739d',
    backgroundColor: '#E1ECF4',
    borderColor: '#96bdd9',
    boxShadow: 'inset 0 1px 0 #f4f8fb',
     position: 'relative', display: 'flex',
justifyContent: 'center',
alignItems: 'center', height: '55px', marginTop: '2rem'}} onClick={() => this.addToFavorites(this.state.selected_machine_name)}><img
                  src="https://www.fasttrackracingteam.com/IMAGES/INGREDIENTS/GRAPHIC_favorite.ico" style={{width: '50px', height: '50px', position: 'absolute', left: '0px'}}/>
                  <span>Add To<br/>Favorites</span><img src="https://www.fasttrackracingteam.com/IMAGES/INGREDIENTS/GRAPHIC_favorite.ico" style={{width: '50px', position: 'absolute', right: '0px'}}/></button>
                }
                {this.state.userModified.favorites && this.state.userModified.favorites.includes(this.state.selected_machine_name) &&
                <div style={{marginTop: '2rem'}}><strong>One your favorites!</strong>
                  <button style={{width: '100%', color: '#39739d',
    backgroundColor: '#E1ECF4',
    borderColor: '#96bdd9',
    boxShadow: 'inset 0 1px 0 #f4f8fb'}} onClick={() => this.addToFavorites(this.state.selected_machine_name)}>Remove From Favorites</button>
                </div>
                }

                <a className={'btn btn-info'} style={{marginTop: '2rem'}} target="_blank" href={this.state.selected_url}>View recipe on<br/>{this.state.selected_domain}</a>

              </div>
              <div style={{ paddingLeft: '20px'}}><img src={this.state.selected_img_url}/></div>
            </div>
            {ingredients.items && this.state.selected_ingredients &&
            <div style={parent}>
              {this.state.selected_ingredients.map((myIngredient, index) =>
                <IngredientSlide key={myIngredient} noLink match={myIngredient} ingredients={ingredients} youGotThis={this.state.userModified.cabinet && this.state.userModified.cabinet.includes(myIngredient)}/>
              )}
            </div>
            }
            {user.access_level > 5 &&
            <div><NavLink to={`/recipe/${this.state.selected_machine_name}`}>View details</NavLink></div>
            }

            <button style={{width: '100%', height: '4rem', marginTop: '.5rem'}} onClick={this.closeModal}>Close</button>

          </div>
          </section>
          </section>
        </Modal>


        {this.state.userModified.first_name != 'Guest' &&
        <h1 style={{display: 'none'}}>Hi {this.state.userModified.first_name}</h1>
        }

        {(!my_recipes || !my_recipes.items || !my_recipes.items.length) && (!this.state.userModified.keyIngredients || !this.state.userModified.keyIngredients.length) &&
        <div>
          <h1>No booze!</h1>
          <h3>Get the party <NavLink to={'/'}>started</NavLink> by adding ingredients to your bar.</h3>
          <p>The purpose of this page is to list only the cocktails which you have all the ingredients for.  Once you stock your bar, come back here to see all the great cocktails that can help you get the party started.</p>
        </div>
        }

        {my_recipes.loading &&
        <div style={{height: "275px"}}>
        <Spinner />
          </div>
        }

        {!(!my_recipes || !my_recipes.items || !my_recipes.items.length) && my_recipes.items[0].missing.length > 0 &&
        <div>
        <h1>Short on the booze!</h1>
        <h3>Return to the <NavLink to={'/'}>home</NavLink> page to add <strong>more </strong> ingredients to your bar.</h3>
          <p>The purpose of this page is to list only the cocktails which you have all the ingredients for.  While the home page lists several cocktails, they all are missing 1 or more ingredients.</p>
          </div>
        }
        {!(!my_recipes || !my_recipes.items || !my_recipes.items.length) && my_recipes.items[0].missing.length == 0 &&
        <div>

          <h1>Pick a Cocktail... the host has all the ingredients!</h1>
          <h2>{sweetCocktails.length + strongCocktails.length + creamyCocktails.length + bitterCocktails.length + frozenCocktails.length} cocktails are ready to be made</h2>

          <Tabs style={{position: 'relative',
    overflow: 'hidden',
    margin: '0 auto',
    width: '100%',
    marginBottom: '1.2rem',
    fontWeight: 300
    }}>
            <nav className={`categories-${countCategories}`}>
              <TabList style={{fontSize: '1.25em'}}>
                {sweetCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-home"><span>Sweet</span></a></Tab>
                }
                {strongCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-box"><span>Strong</span></a></Tab>
                }
                {creamyCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-display"><span>Creamy</span></a></Tab>
                }
                {bitterCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-upload"><span>Bitter</span></a></Tab>
                }
                {frozenCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-tools"><span>Frozen</span></a></Tab>
                }
              </TabList>
            </nav>


            {sweetCocktails.length > 0 &&
            <TabPanel>
              {my_recipes.error && <span className="text-danger">ERROR: {my_recipes.error}</span>}
              {sweetCocktails &&
              <RecipeCategory cocktailCategory={sweetCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
            {strongCocktails.length > 0 &&
            <TabPanel>

              {strongCocktails &&
              <RecipeCategory cocktailCategory={strongCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
            {creamyCocktails.length > 0 &&
            <TabPanel>
              {creamyCocktails &&
              <RecipeCategory cocktailCategory={creamyCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
            {bitterCocktails.length > 0 &&
            <TabPanel>
              {bitterCocktails &&
              <RecipeCategory cocktailCategory={bitterCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
            {frozenCocktails.length > 0 &&
            <TabPanel>
              {frozenCocktails &&
              <RecipeCategory cocktailCategory={frozenCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
          </Tabs>
        </div>
        }

      </div>
    );
  }
}
// https://storage.googleapis.com/coverflow-react/index.html

function mapStateToProps(state) {
  const { authentication, my_recipes, ingredients, alert } = state;
  const { user } = authentication;
  return {
    user,
    my_recipes,
    ingredients,
    alert
  };
}

const connectedPartyTime = connect(mapStateToProps)(PartyTime);
export { connectedPartyTime as PartyTime };


// WEBPACK FOOTER //
// ./src/PartyTime/PartyTime.jsx